<template>
  <div class="domain-data" :id="operationId">
    <operation-value
      :key="operationId"
      :element="element"
      :operations="operations"
      :container="'#' + operationId + '.domain-data'"
      :getLang="getLang"
    />
    <transition name="fade" mode="out-in">
      <div v-if="showResponses" class="section-value">
        <span class="label"><i class="fas fa-tasks"></i> {{ getLang('responseSelection') }}</span>
        <div class="responses-list"
          @mousedown.stop
          @touchstart.stop
          @pointerdown.stop
          @dragstart.stop
          @click.stop
        >
          <dual-list v-if="element.operation.domain"
            :key="'dual-list_' + element.id"
            :domain="element.operation.domain"
            :getLang="getLang"
            :selected="selected"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Configuration from '@/configuration'
import * as api from '../definitionLoader/utils/definitionApi'
import moment from 'moment'
import dualList from './dualList'
import operationValue from './operationValue'

export default {
  name: 'domain-data',
  components: {
    dualList,
    operationValue
  },
  props: {
    element: Object,
    domainEndpoint: String,
    currentLanguage: String,
    segmentId: String,
    getLang: Function,
    selected: Boolean,
    openDomain: Boolean,
    sendConditionResume: Function
  },
  data () {
    return {
      loadingDomain: false
    }
  },
  methods: {
    loadDomain () {
      if (!this.element.operation.domain) {
        this.$emit('loadingDomain', true)
        api.call({domainEndpoint: Configuration.value('API_SERVICES_URL') + moment().valueOf(), url: this.domainEndpoint, token: null, version: null, method: 'POST', lang: this.currentLanguage, authorization: window.localStorage.getItem('user-token'), data: { id: this.segmentId, code: this.element.id }})
          .then(resp => {
            if (resp) {
              this.element.operation.domain = resp
            }
            this.$emit('domainLoaded')
          })
          .catch(err => {
            console.log(err)
            this.$emit('loadingDomain', false)
          })
      } else {
        this.$emit('domainLoaded')
      }
    },
    radioClick (key) {
    },
    getValuesStr () {
      if (this.element.operation && this.element.operation.domain && this.showResponses) {
        const selected = this.element.operation.domain.selected
        if (selected && selected.length) {
          // extraemos solo los nombres y los unimos con ', '
          const names = selected.map(item => '\'' + item.name + '\'').join(', ')
          return `: ${names}`
        }
        return ''
      } else {
        return ''
      }
    }
  },
  beforeMount () {
    this.loadDomain()
  },
  computed: {
    showResponses () {
      return !['informed', 'not-informed'].includes(this.element.operation.operationValue)
    },
    operations () {
      return [
        {key: 'contains-some', name: this.getLang('opDomainContainsSomeName'), description: this.getLang('opDomainContainsSomeDesc')},
        {key: 'contains-all', name: this.getLang('opDomainContainsAllName'), description: this.getLang('opDomainContainsAllDesc')},
        {key: 'not-contains', name: this.getLang('opDomainNotContainsName'), description: this.getLang('opDomainNotContainsDesc')},
        {key: 'equal', name: this.getLang('opDomainEqualName'), description: this.getLang('opDomainEqualDesc')},
        {key: 'informed', name: this.getLang('opDomainInformedName'), description: this.getLang('opDomainInformedDesc')},
        {key: 'not-informed', name: this.getLang('opDomainNotInformedSomeName'), description: this.getLang('opDomainNotInformedSomeDesc')}
      ]
    },
    operationId () {
      return 'operation_' + this.element.id
    }
  },
  watch: {
    showResponses (value) {
      this.$emit('showResponses', value)
    },
    openDomain (value) {
      if (value) {
        this.loadDomain()
      }
    },
    element: {
      handler () {
        this.sendConditionResume(this)
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss">
.domain-data {
}
</style>
